"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "defaultRadius", {
    enumerable: true,
    get: function() {
        return defaultRadius;
    }
});
var defaultRadius = {
    "radii-half": "0.125rem",
    "radii-1": "0.25rem",
    "radii-2": "0.375rem",
    "radii-3": "0.5rem",
    "radii-4": "0.75rem",
    "radii-5": "1rem",
    "radii-6": "1.5rem",
    "radii-card": "0.5rem",
    "radii-modal": "0.5rem",
    "radii-alertdialog": "0.5rem",
    "radii-popover": "0.5rem",
    "radii-button": "0.375rem"
};
